// extracted by mini-css-extract-plugin
export default {"fullMessage":"FullMessageOverlay_fullMessage__1KAsW"};